import { combineReducers } from 'redux';
import createReducer, { reducerHandler } from '../../reducerHelper';
import * as types from './types';

const patientUpdatedTrigger = createReducer({
  patientId: null,
  prev: null,
})({
  [types.UPDATE_PATIENT_TRIGGER]: (state, action) => {
    return {
      ...action.payload,
      prevPatientId: state.patientId,
    };
  },
});

export const PATIENT_REDUCERS = {
  PATIENT_UPDATED_TRIGGER: 'patientUpdatedTrigger',
};
export default combineReducers({
  [PATIENT_REDUCERS.PATIENT_UPDATED_TRIGGER]: patientUpdatedTrigger,
  [types.UPDATE_SELECTED_TAB]: reducerHandler(types.UPDATE_SELECTED_TAB),
});



// WEBPACK FOOTER //
// ./src/state/reducers/patient/patientReducers.js